export const parsePublishedAt = (publishedAt: string) => {
    const date: Date = new Date(publishedAt);

    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
};

export const isURL = (url: string) => {
    try {
        new URL(url);
        return true;
    } catch (e) {
        return false;
    }
};
